import axios from "axios";
import config from "../config";
import { TemplatesResponse } from "./ResponseModels/TemplatesResponse";

export async function GetTemplatesModel() {
  let response = null;
  response = axios
    .get<TemplatesResponse>(config.getConfigurationsEndpoint, {})
    .catch((e) => {
      // TODO manage
      console.error("There was an error!", e);
    });

  return response;
}
